// components/Navbar.js
import React, { useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-gray-800 p-4 w-full">
      <div className="flex justify-between items-center">
        <div className="text-white text-2xl font-bold">Vilas Lamani,<span className='text-white text-gray-500 text-sm font-bold ml-2'>Software Engineer</span></div>

        {/* Hamburger Menu for Mobile */}
        <button
          onClick={toggleMenu}
          className="text-white block lg:hidden focus:outline-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>

        {/* Links for larger screens */}
        <ul className="hidden lg:flex justify-center mr-8 space-x-6 text-white">
          <li><a href="#about" className="hover:text-gray-400">About</a></li>
          <li><a href="#experience" className="hover:text-gray-400">Experience</a></li>
          <li><a href="#skills" className="hover:text-gray-400">Skills</a></li>
          <li><a href="#certifications" className="hover:text-gray-400">Certifications</a></li>
          <li><a href="#projects" className="hover:text-gray-400">Projects</a></li>
          <li><a href="#contact" className="hover:text-gray-400">Contact</a></li>
        </ul>
      </div>

      {/* Dropdown Menu for Mobile */}
      <div className={`lg:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <ul className="flex flex-col items-center space-y-4 mt-4 text-white">
          <li><a href="#about" onClick={toggleMenu} className="hover:text-gray-400">About</a></li>
          <li><a href="#experience" onClick={toggleMenu} className="hover:text-gray-400">Experience</a></li>
          <li><a href="#skills" onClick={toggleMenu} className="hover:text-gray-400">Skills</a></li>
          <li><a href="#certifications" onClick={toggleMenu} className="hover:text-gray-400">Certifications</a></li>
          <li><a href="#projects" onClick={toggleMenu} className="hover:text-gray-400">Projects</a></li>
          <li><a href="#contact" onClick={toggleMenu} className="hover:text-gray-400">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
